import * as AK from '@ariakit/react'

export interface LabelProps extends AK.FormLabelProps {}

export const Label = (props: LabelProps) => (
  // N.B. Don't use <AK.FormLabel render={<S.Label />} />
  // because AK.FormLabel can render as label or span depending on the kind of
  // input. See https://ariakit.org/reference/form-label
  //
  // If you need something polymorphic, use as={AK.FormLabel} instead.
  <AK.FormLabel {...props} />
)
